import React from 'react';
import { Link } from 'react-router-dom';
import { BASE as API_BASE } from '../services/api';

export default function AdCard({ ad }) {
  if (!ad) return null;
  const thumb = ad.thumbnailUrl && ad.thumbnailUrl.startsWith('/uploads/') ? `${API_BASE}${ad.thumbnailUrl}` : ad.thumbnailUrl;
  return (
    <Link to={`/ads/${encodeURIComponent(String(ad._id))}`} style={{ textDecoration: 'none' }}>
      <div style={{ background: '#111827', border: '1px solid #374151', borderRadius: 12, overflow: 'hidden', width: 240 }}>
        <div style={{ aspectRatio: '16/9', background: '#0b0b0e' }}>
          {thumb ? (
            <img
              src={thumb}
              alt={ad.title || 'Ad'}
              loading="lazy"
              decoding="async"
              fetchpriority="low"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          ) : (
            <div style={{ width: '100%', height: '100%' }} />
          )}
        </div>
        <div style={{ padding: 10 }}>
          <div style={{ color: '#e5e7eb', fontWeight: 600, fontSize: 14, lineHeight: 1.2 }}>
            {ad.title || 'Ad Video'}
          </div>
          <div style={{ color: '#9ca3af', fontSize: 12, marginTop: 4 }}>
            {ad.createdAt ? new Date(ad.createdAt).toLocaleString() : ''}
          </div>
        </div>
      </div>
    </Link>
  );
}
